import * as React from "react";
import Button from "./Button";
import { QuickReplyButton } from "../types";

interface ChatQuickRepliesProps {
  quickReplies: Array<QuickReplyButton>;
  onClick: (response: QuickReplyButton) => void;
}

class ChatQuickReplies extends React.Component<ChatQuickRepliesProps, {}> {
  onClick(button: QuickReplyButton) {
    this.props.onClick(button);
  }

  renderQuickReply(button: QuickReplyButton, key: number) {
    return (
      <Button
        className="quick-reply-btn"
        onClick={(e: any) => this.onClick(button)}
        key={key}
        variant="reply"
      >
        {button.label}
      </Button>
    );
  }

  render() {
    const quickReplies = this.props.quickReplies;

    if (!quickReplies || quickReplies.length === 0) {
      return null;
    }

    return (
      <div className="velaro-quick-replies">
        {quickReplies.map((qr, i) => this.renderQuickReply(qr, i))}
      </div>
    );
  }
}

export default ChatQuickReplies;
